import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-plum" data-id="element-45" data-mp="1zyh2w7skw2x2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-46" data-mp="1uy2xkxid372q">
        <h2 className="font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-47" data-mp="1v05w65xky8j2">
          Keep your nights.{' '}
          <span className="text-gold" data-id="element-48" data-mp="1l05bognz5mda">Open the practice and run it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-49" data-mp="1l1zxryazfkiy">
          Build the room, attack on your feet, own the mat, chain it together,
          hold the line, peak for the postseason. Ninety practices — planned,
          clocked and ready.
        </p>

        <div className="mt-7" data-id="element-50" data-mp="17abl9twtmu1g">
          <Countdown size="sm" tone="dark" data-id="element-51" data-mp="176xjonvzeov2" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-52" data-mp="128cj2ncti363">
          <div data-id="element-53" data-mp="3vevgjpzqgpof">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-54" data-mp="3vf5afonwfgze">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-55" data-mp="42tzgknc3rie">
              Wrestling Practice Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-56" data-mp="3qh3rd3qh3hnx">
            <span className="font-display text-4xl font-semibold leading-none text-white" data-id="element-57" data-mp="i0s3ox7xy7k6">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-58" data-mp="mytygfeqbvbh">
          <CtaButton data-id="element-59" data-mp="82ugmd1tigt5">Yes, I want the full season — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-60" data-mp="d1fiegwpx8jp">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-61" data-mp="2xrmzc76rm2s8">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-62" data-mp="2xsy4aaby5gkx" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}